"use client";

import * as MainI from "./MainInterface";
// import { initializeApp, getApps, getApp, FirebaseApp } from "firebase/app";
// import { getAnalytics } from "firebase/analytics";
// import { getFunctions } from 'firebase/functions';
// import { getAuth } from "firebase/auth"
// import { getFirestore } from 'firebase/firestore';
// import { getStorage } from 'firebase/storage';


// const firebaseConfig = {
//   apiKey: "AIzaSyCf4vNooGaYXqz05WTumMz4Ar4bOqJynY8",
//   authDomain: "cudent-412b4.firebaseapp.com",
//   databaseURL: "https://cudent-412b4.firebaseio.com",
//   projectId: "cudent-412b4",
//   storageBucket: "cudent-412b4.appspot.com",
//   messagingSenderId: "158705206764",
//   appId: "1:158705206764:web:3c74b1d6267708c3e2acc9"
// };

import { app, storage, analytics, db } from "@/lib/Firebase";


let appFirebase = app
// if (!app.apps.length) {
//   app.initializeApp(firebaseConfig);
// }

// let db: app.firestore.Firestore = app.firestore();
// let storage: app.storage.Storage = app.storage();

export default class MainController {

  getState: () => MainI.State;
  setState: (state: MainI.State, callback?: any) => void;
  data: MainI.Data;
  app ;
  user: any;
  group: any;
  db;
  // db: app.firestore.Firestore;
  analytics ;
  storage
  // auth;
  // function; 
  // storage: app.storage.Storage;
  useCloud: boolean;
  config: any;
  isIschart?: boolean;
  urlPrefix: string;
  // ของที่ผูกกับ Me ตัวนี้ ต้องเก็บกวาดใน WillUnmount
  authUnsubscribe?: () => void;
  socketMessageHandler?: (message: any) => void;
  unmounted?: boolean;
  // กัน response เก่าทับใหม่เมื่อ GetDatasetList ถูกเรียกซ้อนกันบน controller เดียวกัน
  datasetListSeq: number;

  constructor(
    getState: () => MainI.State, 
    setState: (state: MainI.State, callback?: any) => void,
    useCloud: boolean,
    config?: any)
  {
    this.getState = getState;
    this.setState = setState;
    this.data = MainI.DataInitial;
    // this.app = app;
    this.app = appFirebase
    this.user = null;
    this.group = null;
    this.db = db
    this.storage = storage
    this.useCloud = useCloud;
    this.config = config;
    this.analytics = analytics
    // this.urlPrefix = '/media/ischart/';
    this.urlPrefix = '';
    this.unmounted = false;
    this.datasetListSeq = 0;
  }
  
  handleEvent = async (e: MainI.Event) => {
    // console.log(e.message, e.params)
    switch (e.message) {
      case "DidMount":
        return await MainI.DidMount(this, e.params);
    
      case "DidUpdate":
        return await MainI.DidUpdate(this, e.params);

      case "WillUnmount":
        return await MainI.WillUnmount(this, e.params);

      case "Login":
        return await MainI.Login(this, e.params);

      case "Logout":
        return await MainI.Logout(this, e.params);

      case "GetChartData":
        return await MainI.GetChartData(this, e.params);

      case "GetCustomChartData":
        return await MainI.GetCustomChartData(this, e.params);

      case "GetDatasetList":
        return await MainI.GetDatasetList(this, e.params);

      case "GetChartInfo":
        return await MainI.GetChartInfo(this, e.params);

      case "LoadChartInfoOne":
        return await MainI.LoadChartInfoOne(this, e.params);

      case "GetTemplateList":
        return await MainI.GetTemplateList(this, e.params);

      case "AddTemplate":
        return await MainI.AddTemplate(this, e.params);

      case "GenInformatics":
        return await MainI.GenInformatics(this, e.params);

      case "GetFields":
        return await MainI.GetFields(this, e.params);

      case "GetRecipe":
        return await MainI.GetRecipe(this, e.params);

      case "AddRecipeItem":
        return await MainI.AddRecipeItem(this, e.params);

      case "GetGaDashboardData":
        return await MainI.GetGaDashboardData(this, e.params);

      case "GetMelabReportBundle":
        return await MainI.GetMelabReportBundle(this, e.params);

      case "QueryMelabReport":
        return await MainI.QueryMelabReport(this, e.params);

      default:
        let testExhausitve: never = e
    }
    console.log("-- Unhandled case");
  }
}
